import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=1b739a40&"
import script from "./Devices.vue?vue&type=script&lang=js&"
export * from "./Devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b739a40')) {
      api.createRecord('1b739a40', component.options)
    } else {
      api.reload('1b739a40', component.options)
    }
    module.hot.accept("./Devices.vue?vue&type=template&id=1b739a40&", function () {
      api.rerender('1b739a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices.vue"
export default component.exports